import { TasksRelationsState } from '@hkm/components/TaskManagement/relations/domain/interfaces';
import { Store } from '@hkm/store/interfaces/store';

export const getRelationsState = (state: Store): TasksRelationsState =>
  state.tasks.relations;



// WEBPACK FOOTER //
// ./src/components/TaskManagement/relations/domain/selectors.ts